import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { apiService } from "../services/api";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState<{ type: "ok" | "err"; text: string } | null>(null);

  const save = async () => {
    setMsg(null);
    if (next.length < 8) return setMsg({ type: "err", text: "New password must be at least 8 characters" });
    if (next !== confirm) return setMsg({ type: "err", text: "Passwords do not match" });
    setSaving(true);
    try {
      await apiService.changePassword({ currentPassword: current, newPassword: next });
      setMsg({ type: "ok", text: "Password changed" });
      setTimeout(() => navigate(-1), 700);
    } catch (e: any) {
      setMsg({ type: "err", text: e?.response?.data?.message || e?.message || "Change failed" });
    } finally {
      setSaving(false);
    }
  };

  const field = (label: string, val: string, set: (v: string) => void) => (
    <>
      <label className="block text-sm text-gray-600 dark:text-gray-400 mb-1 font-['Product_Sans']">{label}</label>
      <input
        type="password"
        value={val}
        onChange={(e) => set(e.target.value)}
        className="w-full mb-4 px-4 py-3 rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-300 dark:border-white/10 focus:border-blue-500 outline-none text-black dark:text-white"
      />
    </>
  );

  return (
    <div className="min-h-screen bg-white dark:bg-black text-black dark:text-white transition-colors duration-300">
      <div className="max-w-xl mx-auto px-5 pt-6">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white mb-6 transition-colors">
          <ChevronLeft size={20} /> Back
        </button>
        <h1 className="text-2xl font-semibold mb-6 font-['Caviar_Dreams']">Change Password</h1>
        {field("Current password", current, setCurrent)}
        {field("New password", next, setNext)}
        {field("Confirm new password", confirm, setConfirm)}
        {msg && (
          <div className={`mb-4 text-sm font-['Product_Sans'] ${msg.type === "ok" ? "text-green-600 dark:text-green-400" : "text-red-500 dark:text-red-400"}`}>{msg.text}</div>
        )}
        <button
          onClick={save}
          disabled={saving || !current || !next}
          className="w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-500 disabled:opacity-50 font-semibold text-white transition-colors"
        >
          {saving ? "Saving…" : "Update Password"}
        </button>
      </div>
    </div>
  );
}